export class UserModel {
    id: string;
    nombre: string;
    apellidos: string;
    password: string;
    rol: string;
    username: string;
    documentos: string;
    //EXCLUDE

    constructor(username: string, password: string){
        this.username = username;
        this.password = password;
    }
}
